import script from "./File.vue?vue&type=script&lang=ts&setup=true"
export * from "./File.vue?vue&type=script&lang=ts&setup=true"

import "./File.vue?vue&type=style&index=0&id=58acaceb&lang=less"
import "./File.vue?vue&type=style&index=1&id=58acaceb&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58acaceb"]])

export default __exports__